(() => {
  if (window.dwFullImageViewportReady) return;
  window.dwFullImageViewportReady = true;
  function resize() {
    const width = document.documentElement.clientWidth + 'px';
    document.querySelectorAll('.dw-full-image-section').forEach(section => {
      if (section.style.getPropertyValue('--dw-image-viewport') !== width) {
        section.style.setProperty('--dw-image-viewport', width);
      }
    });
  }
  resize();
  window.addEventListener('resize', resize, {passive:true});
  document.addEventListener('shopify:section:load', resize);
  new ResizeObserver(resize).observe(document.documentElement);
})();
